<template>
  <div>
    <h3>Contrats</h3>
    <template v-for="contract in contracts">
      <component :is="handleContractType(contract)"
                 :contract="prepareContract(contract)"
                 :key="'customer-contract-'+contract.id">
      </component>
    </template>
  </div>
</template>


<script type="text/babel">
  import Domiciliation from './Contracts/Domiciliation'
  import LongTermLocation from './Contracts/LongTermLocation'

  export default {
    components: {
      Domiciliation,
      LongTermLocation
    },

    props: ["contracts", "orders"],

    methods: {
      handleContractType (contract) {
        return contract.type === "domiciliation_contract" ?
          "Domiciliation" : "LongTermLocation"
      },

      findAssociatedOrder (contract) {
        return _.find(
          this.orders,
          ['id', contract.order_id]
        )
      },

      prepareContract (contract) {
        const order = this.findAssociatedOrder(contract)

        return order ? {
          ...contract,
          order
        } : contract
      },

    },
  }
</script>


<style lang="scss">
  .informations-contract {
    .contract-details {
      tr {
        td {
          line-height: 24px;
        }
      }
      .contract-address {
        li {
          list-style-type: none;
          display: flex;
          justify-content: space-between;
          button {
            max-height: 32px;
          }
          .circle {
            left: -17px;
            top: 7px;
          }
        }
      }
      .options {
        padding: 0 0 0 10px;
        list-style-type: none;
        li {
          padding: 0;
          &::before {
            content: '- ';
          }
        }
      }
      .status-flags {
        padding: 0;
        list-style-type: none;
        display: flex;
        flex-wrap: wrap;
        li {
          width: 42%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Contracts.vue